import SemrTooltip from '@semcore/ui/tooltip';

export const Tooltip = SemrTooltip;
